import { AbstractAccessor } from 'sdkore';

export class BookingsAccessor extends AbstractAccessor {
    constructor() {
        super('/public/booking_management/bookings');
    }
}
